<template>
  <div class="flex min-h-screen bg-gray-100">
    <AdminSidebar />
    <main class="flex-1 p-8">
      <router-view />
    </main>
  </div>
</template>

<script setup lang="ts">
import AdminSidebar from './AdminSidebar.vue';
</script>

